
const RepeatPasswordValidation = (value, form) => {

    if (value !== form.password) {
        return 'Passwords must be equal!';
    }
    return undefined;
};

export default RepeatPasswordValidation;